'use es6';

import { Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  hasAdwords: false,
  hasAdwordsPermissions: false,
  hasAnyAccountConnected: false,
  hasFacebook: false,
  hasFacebookPermissions: false,
  hasLinkedIn: false,
  hasLinkedInPermissions: false,
  status: RequestStatus.UNINITIALIZED
};
export default class Ads extends Record(DEFAULTS) {
  static fromJS({
    hasAdwords,
    hasAdwordsPermissions,
    hasAnyAccountConnected,
    hasFacebook,
    hasFacebookPermissions,
    hasLinkedIn,
    hasLinkedInPermissions
  }) {
    return new Ads({
      hasAdwords,
      hasAdwordsPermissions,
      hasAnyAccountConnected,
      hasFacebook,
      hasFacebookPermissions,
      hasLinkedIn,
      hasLinkedInPermissions,
      status: RequestStatus.SUCCEEDED
    });
  }

}